import { Container } from "./styles";
import Moment from 'react-moment';
import { formatDateTimeWithBrasiliaConversion } from '../../../utility/timezoneUtils';
import { formatarCep } from '../../../utility/formatadorCep';

export default function BlocoEnderecoProposta({ dadoInicial, infoComarca }: { dadoInicial: any, infoComarca: any }) {

    if (!dadoInicial) {
        return null;
    }

    return (
        <Container>
            <div className="title-service">
                {
                    dadoInicial?.descricao_categoria_servico?.split(' ')[0] === 'Audiências' ? 'Audiência' : 
                    dadoInicial?.descricao_categoria_servico?.split(' ')[0] === 'Diligências' ? 'Diligência' : 
                    dadoInicial?.descricao_categoria_servico?.split(' ')[0] === 'Protocolos' ? dadoInicial?.titulo_servico : 
                    dadoInicial?.descricao_categoria_servico?.split(' ')[0] === 'Outros' ? 'Outros' : ''
                }
                {' '}
                {
                    dadoInicial?.titulo_servico?.split(' ')[0] === 'Protocolo' || 
                    dadoInicial?.titulo_servico?.split(' ')[0] === 'Acautelamento' ? '' :
                    dadoInicial?.titulo_servico?.split(' ')[0]
                }

            </div>

            <div className="countie-process">
                <div className="title-infos">
                    <span>Natureza do processo:</span>
                    <div className="info">
                        {dadoInicial?.natureza || 'Não informado'}
                    </div>
                </div>
                <div className="title-infos">
                    <span>{dadoInicial?.natureza === 'Judicial' ? 'Número do processo:' : 'Número de identificação:'}</span>
                    <div className="info">
                        {
                            dadoInicial?.numero_processo
                            ? dadoInicial.numero_processo
                            : 'Número não informado'
                        }
                    </div>
                </div>
            </div>
            <div className="countie-process">
                <div className="title-infos">
                    <span>Comarca:</span>
                    <div className="info">
                        {infoComarca?.uf ? `${infoComarca.uf} | ${infoComarca.cidade || ''}` : 'Não informado'}
                    </div>
                </div>
            </div>
            {
                dadoInicial?.descricao_categoria_servico?.split(' ')[0] === 'Audiências' &&
                <>
                    <div className="countie-process">
                        <div className="title-infos">
                            <span>Subtipo:</span>
                            <div className="info">
                                {
                                    dadoInicial?.tipo_audiencia
                                        ? dadoInicial.tipo_audiencia
                                        : 'Sem subtipo'
                                }
                            </div>
                        </div>
                        <div className="title-infos">
                            <span>Modalidade:</span>
                            <div className="info">
                                {
                                    dadoInicial?.modalidade
                                        ? dadoInicial?.modalidade
                                        : 'Sem modalidade'
                                }
                            </div>
                        </div>
                    </div>

                    <div className="countie-process">
                        <div className="title-infos">
                            <span>Profissional necessário:</span>
                            <div className="info">
                                {
                                    dadoInicial?.profissional_necessario
                                        ? dadoInicial.profissional_necessario === 'Advogado_Preposto'
                                            ? 'Advogado + Preposto'
                                            :   dadoInicial.profissional_necessario
                                        : 'Sem profissional necessário'
                                }
                            </div>
                        </div>
                    </div>
                </>
            }

            <div className="countie-process">
                <div className="title-infos">
                    <span>Prazo Fatal:</span>
                    <div className="info">
                        {
                            dadoInicial?.data !== null && dadoInicial?.data !== undefined
                                ? formatDateTimeWithBrasiliaConversion(dadoInicial.data, dadoInicial.data_tz)
                                : 'Sem data'
                        }
                    </div>
                </div>
            </div>


            <div className="address">
                <span>Endereço físico:</span>
                {
                    dadoInicial?.modalidade === 'online'
                        ? <div className="address-info">
                            <div className="info">Apenas endereço virtual</div>
                        </div>
                        : <div className="address-info">
                            <div className="info">
                                {
                                    dadoInicial?.rua
                                        ? dadoInicial.rua
                                        : 'End. não informado'
                                }
                            </div>
                            {dadoInicial?.numero && ( <div className="info">nº {dadoInicial.numero}</div> )}
                            {dadoInicial?.bairro && ( <div className="info">{dadoInicial.bairro}</div> )}
                            {dadoInicial?.cep && ( <div className="info">{formatarCep(dadoInicial.cep)}</div> )}
                            {
                                dadoInicial?.complemento !== ''
                                    ? <div className="info">{dadoInicial?.complemento}</div>
                                    : ''
                            }
                        </div>
                }

            </div>

            {
                dadoInicial?.endereco_virtual &&
                    <div className="virtual-address">
                    <div className="title-infos">
                        <span>Endereço virtual:</span>
                        {
                            dadoInicial?.modalidade === 'presencial'
                                ? 'Apenas presencial'
                                : <div className="info">{dadoInicial?.endereco_virtual}</div>
                        }
                    </div>
                </div>
            }

        </Container>
    )
}